import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { NetworkHelper } from '../helpers/network.helper';
import { CountriesData } from '../interfaces/countries.interface';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CountriesService {
  readonly apiCountryUrl = `${environment.poolApi}/check-country`;
  readonly apiUrl = `assets/json/countries.json`;

  public countriesData!: CountriesData;

  constructor(private networkHelper: NetworkHelper) {
    this.getCountries().subscribe((res) => {
      this.countriesData = res;
    });
  }

  getCountries(): Observable<CountriesData> {
    return this.networkHelper.get<CountriesData>(this.apiUrl);
  }

  getCountryByLocation(): Observable<string> {
    return this.networkHelper.get<string>(this.apiCountryUrl, {});
  }
}
